import { can, type Capability } from '@/lib/permission';
import { useAuth } from '@/stores/auth';

/**
 * 已登录且具备该权限点。常驻在壳子或概览上的查询拿它做 `enabled`：
 * 没有权限的读接口干脆不发，免得每次开页都吃一个必然的 403（服务端照样会拒）。
 */
export function useCan(cap: Capability): boolean {
  return useAuth((s) => s.me !== null && can(s.me.roles, cap));
}
